import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import WidgetStatePlaceholder from '../../../components/WidgetStatePlaceholder';
import { mapNotesListData } from './utils/notesListDataMapper';
import NotesListItem from './components/NotesListItem';
import { NOTES_STATE_COPY } from './constants';

/**
 * Notes List widget - per Figma design.
 * States: connection error, system error, empty (with Create CTA), list.
 */
const NotesListWidget = ({
  data = null,
  isCompressed = false,
  error = null,
  errorCode = '',
  onRetry = undefined,
  canRetry = true,
  onItemClick = undefined,
  onCreate = undefined,
}) => {
  const mappedData = useMemo(
    () => mapNotesListData(data),
    [data],
  );

  const handleItemClick = useCallback(
    (item) => {
      onItemClick?.(item);
    },
    [onItemClick],
  );

  if (error) {
    return (
      <WidgetStatePlaceholder
        error={error}
        errorCode={errorCode}
        stateCopy={NOTES_STATE_COPY}
        onRetry={onRetry}
        canRetry={canRetry}
      />
    );
  }

  if (!mappedData.items?.length) {
    return (
      <WidgetStatePlaceholder
        isEmpty
        stateCopy={NOTES_STATE_COPY}
        onEmptyAction={onCreate}
      />
    );
  }

  return (
    <div className="flex flex-col gap-2 w-full">
      {mappedData.items.map((item) => (
        <NotesListItem
          key={item.id}
          item={item}
          isCompressed={isCompressed}
          onItemClick={handleItemClick}
        />
      ))}
    </div>
  );
};

NotesListWidget.propTypes = {
  data: PropTypes.object,
  isCompressed: PropTypes.bool,
  error: PropTypes.object,
  errorCode: PropTypes.string,
  onRetry: PropTypes.func,
  canRetry: PropTypes.bool,
  onItemClick: PropTypes.func,
  onCreate: PropTypes.func,
};


export default React.memo(NotesListWidget);
